import styled from '@emotion/styled';
import { getColor } from '../../../common/UICommon';
import { TabletWidth } from '../../../../global.style';

export const PickAProgramSpecialOfferDisplay = styled.div<{ desktopDisplay: boolean }>`
  ${({ desktopDisplay }) => `display: ${desktopDisplay ? 'flex' : 'none'};`}

  @media (max-width: ${TabletWidth}px) {
    ${({ desktopDisplay }) => `display: ${desktopDisplay ? 'none' : 'flex'};`}
  }
`;

export const PickAProgramSpecialOfferContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;
  text-align: center;
  margin-bottom: 23px;

  @media (max-width: ${TabletWidth}px) {
    margin-bottom: 34px;
  }
`;

export const PickAProgramSpecialOfferWrapper = styled.div`
  width: 327px;
  display: flex;
  flex-direction: column;

  padding: 25px 33px 35px 39px;
  border-radius: 18px;
  background-color: ${getColor('LIGHT_CREAM')};
  margin-bottom: 47px;

  @media (max-width: ${TabletWidth}px) {
    width: calc(100% - 48px);
    margin: 0 24px 72px;
  }
`;

export const PickAProgramSpecialOfferImg = styled.img`
  align-self: center;
  margin-bottom: 6px;
`;

export const PickAProgramSpecialOfferTitle = styled.div`
  color: ${getColor('BLACK')};
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  margin-bottom: 5px;
`;

export const PickAProgramSpecialOfferSubtitle = styled.div`
  color: ${getColor('BLACK')};
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const PickAProgramSpecialOfferBottomTitle = styled.div`
  color: ${getColor('GRAY_70')};
  font-family: Lora;
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;

  @media (max-width: ${TabletWidth}px) {
    font-size: 24px;
  }
`;
